import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { logout } from '@/api/services/auth.api';
import { clearAccessToken } from '@/api/token';
import { PUBLIC_ROUTE } from '@/router/constant/routes';

export function useLogout() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: () => logout(),
        onSettled: () => {
            clearAccessToken();
            queryClient.clear();
            navigate(PUBLIC_ROUTE.LOGIN);
        },
    });
}
